import { useState, useEffect } from 'react';
import ExportService from '../../../services/exportService';
import { CAMPAIGN_STATUS } from '../../../constants/enums';

// Lightweight hook to fetch Outdoor Impact (oiData) once.
// Only triggers when campaignStatus is COMPLETED and an orderlineId exists.
export function useOutdoorImpactData(orderlineId, campaignStatus) {
  const [oiData, setOiData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!orderlineId || campaignStatus !== CAMPAIGN_STATUS.COMPLETED) return;
    const service = new ExportService();
    setLoading(true);
    service.getOiData(
      orderlineId,
      data => {
        setOiData(data);
        setLoading(false);
      },
      () => {
        setError('Failed to load outdoor impact data.');
        setLoading(false);
      }
    );
  }, [orderlineId, campaignStatus]);

  return { oiData, loading, error };
}

export default useOutdoorImpactData;